'use client';

import { useState } from 'react';
import Image from 'next/image';
import { useDevice } from '@/lib/use-device';
import { DownloadModal } from '@/components/download-modal';
import { APP_STORE_URL, PLAY_STORE_URL } from '@/lib/app-store-urls';

export function SmartDownload() {
  const device = useDevice();
  const [showQRModal, setShowQRModal] = useState(false);

  // On mobile devices, show direct download buttons
  if (device === 'ios') {
    return (
      <a
        href={APP_STORE_URL}
        className="inline-block transition-opacity hover:opacity-80"
        aria-label="Télécharger sur l'App Store"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Image
          src="/app-store.svg"
          alt="Télécharger sur l'App Store"
          width={157}
          height={54}
          className="h-auto"
        />
      </a>
    );
  }

  if (device === 'android') {
    return (
      <a
        href={PLAY_STORE_URL}
        className="inline-block transition-opacity hover:opacity-80"
        aria-label="Disponible sur Google Play"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Image
          src="/google-play.svg"
          alt="Disponible sur Google Play"
          width={176}
          height={54}
          className="h-auto"
        />
      </a>
    );
  }

  // On desktop, show both buttons that open QR code modal
  return (
    <>
      <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-4 space-y-4 sm:space-y-0">
        <button
          onClick={() => setShowQRModal(true)}
          className="inline-block transition-opacity hover:opacity-80"
          aria-label="Télécharger sur l'App Store"
        >
          <Image
            src="/app-store.svg"
            alt="Télécharger sur l'App Store"
            width={157}
            height={54}
            className="h-auto"
          />
        </button>
        <button
          onClick={() => setShowQRModal(true)}
          className="inline-block transition-opacity hover:opacity-80"
          aria-label="Disponible sur Google Play"
        >
          <Image
            src="/google-play.svg"
            alt="Disponible sur Google Play"
            width={176}
            height={54}
            className="h-auto"
          />
        </button>
      </div>

      <DownloadModal open={showQRModal} onOpenChange={setShowQRModal} />
    </>
  );
}
